export default {
  severities: 'Úrovne závažnosti',
  allSeverities: 'Všetky úrovne závažnosti',
  doesIncludeHiddenAlarms: 'Zahrnúť skryté alarmy',
};
